module.exports = __webpack_public_path__ + "img/banner.14d96004.png";